/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EodMelcoModelsError,
    EodMelcoModelsErrorFromJSON,
    EodMelcoModelsErrorToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodLog,
    EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodLogToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailToJSON,
} from '../models';

export interface EodSupportApiEodDevicesRequest {
    userId: string;
}

export interface EodSupportApiEodLogsRequest {
    deviceId: string;
}

/**
 * 
 */
export class EodSupportApi extends runtime.BaseAPI {

    /**
     */
    async eodDevicesRaw(requestParameters: EodSupportApiEodDevicesRequest): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling eodDevices.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/{user_id}/devices`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSON(jsonValue));
    }

    /**
     */
    async eodDevices(requestParameters: EodSupportApiEodDevicesRequest): Promise<EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail> {
        const response = await this.eodDevicesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodLogsRaw(requestParameters: EodSupportApiEodLogsRequest): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsEodLog>> {
        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling eodLogs.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/{device_id}/logs`.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters.deviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSON(jsonValue));
    }

    /**
     */
    async eodLogs(requestParameters: EodSupportApiEodLogsRequest): Promise<EodMelcoModelsGenericList1MelcoEodModelsEodLog> {
        const response = await this.eodLogsRaw(requestParameters);
        return await response.value();
    }

}
